import React from 'react';
import Dropdown from 'react-dropdown';

const WhseDropDown = props => {
  return <Dropdown {...props} />;
};

export default WhseDropDown;